import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
// iOS keyboard is now handled via CSS dvh units and viewport meta tag
import "./BottomNavbar.css";

const BottomNavbar = ({ eventId, sponsorCode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/events") {
      return location.pathname === "/events" || location.pathname === "/Events";
    }
    return location.pathname.includes(path);
  };

  const isScanPage = location.pathname.includes("scanDetails");
  const isLeadsPage = location.pathname.includes("view-leads");

  const handleHomeClick = () => {
    navigate("/events");
  };

  const handleScanClick = () => {
    if (eventId && sponsorCode) {
      // If already on scan page, trigger tab switch to scan tab
      if (isScanPage) {
        // Dispatch custom event to switch to scan tab
        window.dispatchEvent(new CustomEvent('switchToScanTab'));
      } else {
        // Navigate to scan page
        navigate({
          pathname: `/events/${eventId}/scanDetails`,
          search: `?sponsor=${sponsorCode}`,
        });
      }
    }
  };

  const handleLeadsClick = () => {
    if (eventId && sponsorCode) {
      navigate({
        pathname: `/events/${eventId}/view-leads`,
        search: `?sponsor=${sponsorCode}`,
      });
    }
  };

  return (
    <div className="bottom-navbar-container">
      {/* SVG Background with curved notch - viewBox starts at y=35 to hide top corners */}
      <svg
        className="bottom-navbar__bg"
        viewBox="0 35 390 76"
        fill="none"
        preserveAspectRatio="none"
        style={{ background: 'transparent', backgroundColor: 'transparent' }}
      >
        <path
          d="M390 111V55C390 43.954 381.046 35 370 35H244.001C234.917 35 227.4 41.534 221.989 48.831C215.57 57.485 205.863 63 195 63C184.137 63 174.43 57.485 168.011 48.831C162.6 41.534 155.083 35 145.999 35H20C8.954 35 0 43.954 0 55V111H390Z"
          fill="white"
          stroke="#E0E1E6"
        />
      </svg>

      {/* Scan button (positioned above navbar) */}
      <button
        className={`bottom-navbar__scan-btn ${isScanPage ? "bottom-navbar__scan-btn--active" : ""}`}
        onClick={handleScanClick}
      >
        <div className="bottom-navbar__scan-icon">
          <Icon icon="lucide:scan-line" width="30" height="30" />
        </div>
        <div>Scan</div>
      </button>

      <nav className="bottom-navbar">
        <button
          className={`bottom-navbar__item ${isActive("/events") && !isScanPage && !isLeadsPage ? "bottom-navbar__item--active" : ""}`}
          onClick={handleHomeClick}
        >
          <Icon icon="hugeicons:home-03" width="24" height="24" />
          <span>Home</span>
        </button>

        <div className="bottom-navbar__spacer" />

        <button
          className={`bottom-navbar__item ${isLeadsPage ? "bottom-navbar__item--active" : ""}`}
          onClick={handleLeadsClick}
        >
          <Icon icon="grommet-icons:group" width="24" height="24" />
          <span>Leads</span>
        </button>
      </nav>
    </div>
  );
};

export default BottomNavbar;
